"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _intlDesignUi = require("@tencent/intl-design-ui");
var _data = require("./data");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const isMockData = false;
const TCE_DATA_COS_URL = '/render/api/configsolution/tceTableInfo';
const formatTable = properties => {
  const _properties$paginatio = properties.paginationOpts,
    paginationOpts = _properties$paginatio === void 0 ? {} : _properties$paginatio,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura; // 第一条数据是模块名称
  const list = configuration.map((item, index) => {
    return _objectSpread(_objectSpread({}, item), {}, {
      key: index + 1
    });
  });
  return {
    configuration: list,
    paginationOpts: {
      placeholder: paginationOpts.placeholder || '',
      pageText: paginationOpts.pageText || '',
      goText: paginationOpts.goText || '',
      resetText: paginationOpts.resetText || '',
      sureText: paginationOpts.sureText || '',
      versionText: paginationOpts.versionText || '',
      featureText: paginationOpts.featureText || '',
      downloadText: paginationOpts.downloadText || '',
      downloadTitle: paginationOpts.downloadTitle || '',
      pageSize: Number(paginationOpts.pageSize) || 5
    }
  };
};

// 处理数据
const doReq = (list, lang, defaultLang = 'en') => {
  let leftOptiosData = [];
  leftOptiosData = list.filter(item => item.language === lang);
  if (leftOptiosData && leftOptiosData.length === 0) {
    // 数据为空用英文兜底
    leftOptiosData = list.filter(item => item.language === defaultLang);
  }
  return leftOptiosData;
};
function findProduct(menu, productGroupCode, productCode) {
  for (const group of menu) {
    if (group.productGroupCode === productGroupCode) {
      for (const product of group.data) {
        if (product.productCode === productCode) {
          return product;
        }
      }
    }
  }
  return null; // 如果没有找到，返回 null
}

// 合并version和feature2个数组为一个group数组
function megeVersionAndFeature(versionList, featureMap) {
  return versionList.map(version => {
    var _featureMap$find;
    const options = ((_featureMap$find = featureMap.find(feature => feature.key === version.key)) === null || _featureMap$find === void 0 ? void 0 : _featureMap$find.data) || [];
    return _objectSpread(_objectSpread({}, version), {}, {
      label: version.text,
      options: options.map(item => {
        return _objectSpread(_objectSpread({}, item), {}, {
          label: item.text,
          value: item.key,
          version: version.key
        });
      })
    });
  });
}
const doDataEvent = (leftOptiosData, urlParams) => {
  var _leftOptiosData$, _leftOptiosData$2;
  const _urlParams$productGro = urlParams.productGroup,
    urlProductGroup = _urlParams$productGro === void 0 ? '' : _urlParams$productGro,
    _urlParams$product = urlParams.product,
    urlProduct = _urlParams$product === void 0 ? '' : _urlParams$product,
    _urlParams$version = urlParams.version,
    urlVersion = _urlParams$version === void 0 ? '' : _urlParams$version,
    _urlParams$feature = urlParams.feature,
    urlFeature = _urlParams$feature === void 0 ? '' : _urlParams$feature,
    _urlParams$hardware = urlParams.hardware,
    urlHardware = _urlParams$hardware === void 0 ? '' : _urlParams$hardware,
    _urlParams$hardwareTy = urlParams.hardwareType,
    urlHardwareType = _urlParams$hardwareTy === void 0 ? '' : _urlParams$hardwareTy;
  const leftOptios = ((_leftOptiosData$ = leftOptiosData[0]) === null || _leftOptiosData$ === void 0 ? void 0 : _leftOptiosData$.productGroupData) || [];
  const leftHardwareOptios = ((_leftOptiosData$2 = leftOptiosData[0]) === null || _leftOptiosData$2 === void 0 ? void 0 : _leftOptiosData$2.hardwareGroupData) || [];
  const menuItems = leftOptios.map(item => {
    return _objectSpread(_objectSpread({
      group: true
    }, item), {}, {
      selectable: false,
      title: item.productGroupName,
      label: item.productGroupName,
      value: item.productGroupCode,
      isExpanded: item.productGroupCode === urlProductGroup,
      isSelected: urlProductGroup === item.productGroupCode,
      // onClick: () => handleGroupClick(item),
      items: (item.data || []).map(item1 => {
        return _objectSpread(_objectSpread({}, item1), {}, {
          label: item1.productName || item1.productCode,
          value: item1.productCode,
          // onClick: () => {
          //   handleItemClick(item1.productCode, item.productGroupCode);
          // },
          isSelected: urlProduct === item1.productCode
        });
      }),
      children: (item.data || []).map(item1 => {
        return _objectSpread(_objectSpread({}, item1), {}, {
          productGroupCode: item.productGroupCode,
          title: item1.productName || item1.productCode,
          value: item1.productCode
        });
      }),
      options: item.data.map(item1 => {
        return _objectSpread(_objectSpread({}, item1), {}, {
          productGroupCode: item.productGroupCode,
          label: item1.productName || item1.productCode,
          value: item1.productCode
        });
      })
    });
  });
  let selectGroupKey = urlProductGroup;
  let selectProductKey = urlProduct;
  let title = '';
  // 辅助函数：设置默认选中项
  const setDefaultMenuItem = () => {
    var _defMenuItem$items, _defMenuItem$items$;
    if (!menuItems || menuItems.length === 0) return null;
    const defMenuItem = menuItems[0] || {};
    selectGroupKey = defMenuItem.productGroupCode || '';
    selectProductKey = defMenuItem === null || defMenuItem === void 0 ? void 0 : (_defMenuItem$items = defMenuItem.items) === null || _defMenuItem$items === void 0 ? void 0 : (_defMenuItem$items$ = _defMenuItem$items[0]) === null || _defMenuItem$items$ === void 0 ? void 0 : _defMenuItem$items$.value;
    return findProduct(leftOptios, selectGroupKey, selectProductKey);
  };
  let selectMenuItem = null;
  if (!selectGroupKey) {
    selectMenuItem = setDefaultMenuItem();
  } else {
    // 查找选中元素
    selectMenuItem = findProduct(leftOptios, selectGroupKey, selectProductKey);

    // 当传入的参数无法找到对应项时，回退到第一个默认值
    if (!selectMenuItem) {
      selectMenuItem = setDefaultMenuItem();
    }
  }
  let versionFeatureListResult = [];
  let productDesc = '';
  let versionList = [];
  let version = urlVersion;
  let feature = urlFeature;
  let featureList = [];
  let featureDetailMap = [];
  let featureDetail = urlHardware;
  let tableList = {};
  let featureDesc = '';
  let selectTitle = '';
  let hardwareTypeMenuItem = {};
  if (selectMenuItem) {
    var _selectMenuItem2;
    const _selectMenuItem = selectMenuItem,
      _selectMenuItem$featu = _selectMenuItem.featureMap,
      featureMap = _selectMenuItem$featu === void 0 ? [] : _selectMenuItem$featu,
      _selectMenuItem$featu2 = _selectMenuItem.featureDetailMap,
      actualFeatureDetailMap = _selectMenuItem$featu2 === void 0 ? [] : _selectMenuItem$featu2,
      _selectMenuItem$versi = _selectMenuItem.versionList,
      actualVersionList = _selectMenuItem$versi === void 0 ? [] : _selectMenuItem$versi,
      _selectMenuItem$produ = _selectMenuItem.productData,
      productData = _selectMenuItem$produ === void 0 ? [] : _selectMenuItem$produ,
      _selectMenuItem$produ2 = _selectMenuItem.productName,
      productName = _selectMenuItem$produ2 === void 0 ? '' : _selectMenuItem$produ2;
    let versionKey = urlVersion;
    let featurekey = urlFeature;
    let featureDetailKey = urlHardware;
    title = productName;
    // 合并version和feature为group数组，方便手机端分组展示
    versionFeatureListResult = megeVersionAndFeature(actualVersionList, featureMap);
    productDesc = (_selectMenuItem2 = selectMenuItem) === null || _selectMenuItem2 === void 0 ? void 0 : _selectMenuItem2.desc;
    versionList = actualVersionList.map(({
      key,
      text
    }) => ({
      value: key,
      label: text
    }));
    // setVersionFeatureList(versionFeatureListResult);
    // setProductDesc(selectMenuItem.desc);
    // setVersionList(actualVersionList.map(({ key, text }) => ({ value: key, label: text })));
    if (actualVersionList !== null && actualVersionList !== void 0 && actualVersionList.length && !versionKey) {
      var _actualVersionList$, _actualVersionList$2;
      versionKey = ((_actualVersionList$ = actualVersionList[0]) === null || _actualVersionList$ === void 0 ? void 0 : _actualVersionList$.key) || '';
      const versionTitle = ((_actualVersionList$2 = actualVersionList[0]) === null || _actualVersionList$2 === void 0 ? void 0 : _actualVersionList$2.text) || '';
      title = title.concat('-', versionTitle);
      version = versionKey;
    } else {
      var _versionItem2;
      let versionItem = actualVersionList.find(item => item.key === versionKey);
      if (!versionItem) {
        var _versionItem;
        versionItem = actualVersionList[0];
        versionKey = ((_versionItem = versionItem) === null || _versionItem === void 0 ? void 0 : _versionItem.key) || '';
        version = versionKey;
      }
      title = title.concat('-', (_versionItem2 = versionItem) === null || _versionItem2 === void 0 ? void 0 : _versionItem2.text);
    }
    if (versionKey) {
      var _featureItem$data;
      const featureItem = featureMap.find(item => item.key === versionKey);
      const featrueList = featureItem.data || [];
      featureList = featrueList.map(({
        key,
        text
      }) => ({
        value: key,
        label: text
      }));
      if (featureItem !== null && featureItem !== void 0 && (_featureItem$data = featureItem.data) !== null && _featureItem$data !== void 0 && _featureItem$data.length && !featurekey) {
        var _featrueList$, _featrueList$2;
        featurekey = ((_featrueList$ = featrueList[0]) === null || _featrueList$ === void 0 ? void 0 : _featrueList$.key) || '';
        const featureTitle = ((_featrueList$2 = featrueList[0]) === null || _featrueList$2 === void 0 ? void 0 : _featrueList$2.text) || '';
        title = title.concat('-', featureTitle);
        feature = featurekey;
      } else {
        var _featrueItem2;
        let featrueItem = featrueList.find(item => item.key === featurekey);
        if (!featrueItem) {
          var _featrueItem;
          featrueItem = featrueList[0];
          featurekey = ((_featrueItem = featrueItem) === null || _featrueItem === void 0 ? void 0 : _featrueItem.key) || '';
          feature = featurekey;
        }
        title = title.concat('-', (_featrueItem2 = featrueItem) === null || _featrueItem2 === void 0 ? void 0 : _featrueItem2.text);
      }
    }
    if (featurekey) {
      var _featureDetailFilter$;
      const featureDetailFilter = actualFeatureDetailMap.find(item => item.key === featurekey);
      const featureDetailList = featureDetailFilter.data || [];
      // 始终更新 featureDetailMap
      featureDetailMap = featureDetailList.map(({
        key,
        text
      }) => ({
        key,
        label: text
      }));
      if (featureDetailFilter !== null && featureDetailFilter !== void 0 && (_featureDetailFilter$ = featureDetailFilter.data) !== null && _featureDetailFilter$ !== void 0 && _featureDetailFilter$.length && !featureDetailKey) {
        var _featureDetailList$, _featureDetailList$2;
        featureDetailKey = ((_featureDetailList$ = featureDetailList[0]) === null || _featureDetailList$ === void 0 ? void 0 : _featureDetailList$.key) || '';
        const featureDetailTitle = ((_featureDetailList$2 = featureDetailList[0]) === null || _featureDetailList$2 === void 0 ? void 0 : _featureDetailList$2.text) || '';
        title = title.concat('-', featureDetailTitle);
        featureDetail = featureDetailKey;
      } else {
        var _featureDetailItem2;
        let featureDetailItem = featureDetailList.find(item => item.key === featureDetailKey);
        if (!featureDetailItem) {
          var _featureDetailItem;
          featureDetailItem = featureDetailList[0];
          featureDetailKey = ((_featureDetailItem = featureDetailItem) === null || _featureDetailItem === void 0 ? void 0 : _featureDetailItem.key) || '';
          featureDetail = featureDetailKey;
        }
        title = title.concat('-', (_featureDetailItem2 = featureDetailItem) === null || _featureDetailItem2 === void 0 ? void 0 : _featureDetailItem2.text);
      }
    }
    if (featureDetailKey) {
      const filterProductData = productData.filter(item => item.version === versionKey) // 筛选版本
      .flatMap(versionItem => versionItem.data.filter(featureItem => featureItem.feature === featurekey) // 筛选功能
      .flatMap(featureItem => featureItem.data.filter(detailItem => detailItem.featureDetailKey === featureDetailKey)));
      if (filterProductData !== null && filterProductData !== void 0 && filterProductData[0]) {
        const tableDataFilter = filterProductData[0];
        tableList = tableDataFilter.data || {};
        featureDesc = tableDataFilter.desc || '';
      }
    }
    selectTitle = title;
  }
  let selectHardwareType = urlHardwareType;
  if (leftHardwareOptios && leftHardwareOptios.length > 0) {
    hardwareTypeMenuItem = leftHardwareOptios.find(item => item.hardwareCode === urlHardwareType);
    if (!hardwareTypeMenuItem) {
      hardwareTypeMenuItem = leftHardwareOptios[0];
      selectHardwareType = hardwareTypeMenuItem.hardwareCode || '';
    }
  }
  return {
    selectGroupKey,
    selectProductKey,
    menuItems,
    selectMenuItem,
    versionFeatureListResult,
    productDesc,
    versionList,
    version,
    feature,
    featureList,
    featureDetailMap,
    featureDetail,
    tableList,
    featureDesc,
    selectTitle,
    hardwareTypeMenuItem,
    selectHardwareType
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  lang = 'en'
}) {
  if (Object.keys(data).length > 1) {
    const _ref = data,
      _ref$tceTableData = _ref.tceTableData,
      tceTableData = _ref$tceTableData === void 0 ? [] : _ref$tceTableData,
      _ref$urlParams = _ref.urlParams,
      urlParams = _ref$urlParams === void 0 ? {} : _ref$urlParams;
    let tceData = [];
    let ssrData = {};
    if (tceTableData.length > 0) {
      tceData = doReq(tceTableData, lang, 'en');
      ssrData = doDataEvent(tceData, urlParams);
    }
    const _formatTable = formatTable(data),
      paginationOpts = _formatTable.paginationOpts,
      configuration = _formatTable.configuration;
    const _React$useState = React.useState(tceData || []),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      psData = _React$useState2[0],
      setPSData = _React$useState2[1];
    const bgStyle = {
      padding: 0
    };
    React.useEffect(() => {
      if (isMockData) {
        const _dataResult$data = _data.dataResult.data,
          list = _dataResult$data === void 0 ? [] : _dataResult$data,
          code = _data.dataResult.code;
        if (code === 0) {
          const tceData = doReq(list, lang, 'en');
          setPSData(tceData);
        } else {
          const data = _data.dataResult.data;
          const tceData = doReq(data, lang, 'en');
          setPSData(tceData);
        }
        return;
      }
      if (tceTableData.length > 0) {
        return;
      }
      _axios.default.get(TCE_DATA_COS_URL).then(({
        data: result
      }) => {
        const _result$data = result.data,
          list = _result$data === void 0 ? [] : _result$data,
          code = result.code;
        if (code === 0) {
          const tceData = doReq(list, lang, 'en');
          setPSData(tceData);
        } else {
          const data = _data.dataResult.data;
          const tceData = doReq(data, lang, 'en');
          setPSData(tceData);
        }
      }).catch(e => {
        // 出错时用mock数据兜底，避免报错
        const data = _data.dataResult.data;
        const tceData = doReq(data, lang, 'en');
        setPSData(tceData);
      });
    }, []);
    return /*#__PURE__*/React.createElement("div", {
      style: bgStyle
    }, /*#__PURE__*/React.createElement(_intlDesignUi.TabTceTable, {
      configuration: configuration,
      data: psData,
      paginationOpts: paginationOpts,
      urlParams: urlParams,
      ssrData: ssrData
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}